const doc = [({"da":({"js":({"admin":({"orders":({"bottom_bar":({"print_shipment_labels_for_orders_in_workplace":"Print pakkelabels for ordrer i arbejdspladsen"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;